import React, { useEffect, useState } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import Pagination from 'components/Pagination';

import {
  Input,
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';

const ChatDialogTreeList = () => {
  const history = useHistory();

  const [dialogTreeInfo, setDialogTreeInfo] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleGetDialogTree = (selectedPage = 1, search = '') => {
    setLoading(true);
    FlexChatIntegration.getAllSearchDialogTree(selectedPage, 10, search)
      .then((response) => {
        setDialogTreeInfo(response.data.result);
        setQuantity(response.data.count);
      })
      .catch((err) => {
        toast.error(
          (err.response && err.response.data.message) ||
            'Erro ao listar Árvores de Diálogo!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetDialogTree();
  }, []);

  const getChatTeeDialogSearch = (event) => {
    handleGetDialogTree(1, event.target.value);
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    handleGetDialogTree(page);
  };

  const controlDelete = (id) => {
    FlexChatIntegration.deleteDialogTree(id)
      .then(() => {
        toast.info('Árvore de Diálogo excluída!', {
          autoClose: 3000,
          closeOnClick: true
        });
        handleGetDialogTree(activePage);
      })
      .catch((err) => {
        toast.error(
          err.response.data.message || 'Ops, algo errado aconteceu!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      });
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/ChatDialogTree/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Árvore de Diálogo</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="12">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Pesquisa por nome"
                          type="text"
                          onChange={(event) => getChatTeeDialogSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={dialogTreeInfo}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            disabled={row.disable}
                            onClick={() =>
                              history.push(`ChatDialogTree/form/${row.id}`)
                            }
                          >
                            <li className="fas fa-edit"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            title="Deletar"
                            size="sm"
                            onClick={() => {
                              window.confirm(
                                'Deseja realmente excluir esse fluxo?'
                              ) && controlDelete(row.id);
                            }}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ChatDialogTreeList;
